import { apiGet, apiPost } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

export async function getCaptcha(): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/captcha`);
}

export async function getAudioCaptcha(): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/audio-captcha`);
}

export async function fetchCaptchaToken(captcha: string): Promise<string> {
  return apiPost({ url: `${config.server}/inspections/token?captcha=${captcha}` });
}
